import { register } from "@rill/loader";
import { getOrganizationPermissions } from "../utils/organization-permissions";
import { getOrganizationRoles } from "../utils/organization-roles";

register(
  {
    name: "usersOrganization",
    meta: ["no-bust", "user"],
    ttl: "5 minutes",
  },
  async ({ api }) => {
    const res = await api("user-organization");
    const data = await res.json();
    const { organizationActiveUsers = [], organizationPendingUsers = [] } =
      data;
    return {
      organizationActiveUsers,
      organizationPendingUsers,
    };
  }
);

register(
  {
    name: "organizationOwner",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const res = await api("organization-owner");
    const data = await res.json();
    const { activeOwnerOrganization = null } = data;
    return activeOwnerOrganization;
  }
);

register(
  {
    name: "organizationRoles",
    meta: ["no-bust", "organization-roles"],
    ttl: "2 hours",
  },
  () => getOrganizationRoles()
);

register(
  {
    name: "organizationPermissions",
    meta: ["no-bust", "organization-permissions"],
    ttl: "2 hours",
  },
  () => getOrganizationPermissions()
);

register(
  {
    name: "organizationBilling",
    meta: ["organizationBilling"],
  },
  async ({ api }, month, year, ownerId, organizationId) => {
    const res = await api("organization-billing", {
      query: {
        month,
        year,
        ownerId,
        organizationId
      },
    });
    const resJSON = await res.json();
    return resJSON;
  }
);
